export const OPENQUERY = 'OPENQUERY'